import { render, staticRenderFns } from "./ProgramDivisionIndex.vue?vue&type=template&id=5423153a&scoped=true&"
import script from "./ProgramDivisionIndex.vue?vue&type=script&lang=js&"
export * from "./ProgramDivisionIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDivisionIndex.vue?vue&type=style&index=0&id=5423153a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423153a",
  null
  
)

export default component.exports